import { FunctionalComponent, h } from '@stencil/core';
import {AppMedia, AppLink} from './'
import get from 'lodash/get'

interface AppContact {
    Name: string;
    Role: string;
    UK?: string;
    Export?: string;
    Media: any;
    Links?: Array<any>;
    Tags? : any;
    Eager?: boolean;
}

export const AppContact: FunctionalComponent<AppContact> = ({ Name, Role, UK, Export, Media, Links, Tags, Eager }) => {

    const tagAttributes = {};
    if (get(Tags, 'data[0]')) {
        Tags.data.forEach(({ attributes: { Group, Label } }) => {
            tagAttributes[`data-${Group}`] ? tagAttributes[`data-${Group}`] += `,${Label}` : tagAttributes[`data-${Group}`] = Label
        })
    }

    return (
        <div  {...tagAttributes} class="uk-margin">
            <div class="uk-grid-collapse"  uk-grid>
                <div class="uk-width-1-3@s uk-cover-container uk-height-min-medium">
                    <AppMedia size="(max-width: 638px) 80vw, (max-width: 958px) 30vw, 20vw" media={Media} cover eager={Eager}/>
                </div>
                <div class="uk-width-2-3@s">
                    <div class="uk-padding uk-background-primary-diag uk-light uk-height-min-medium">
                        <h3 class="uk-heading-medium wsio-darker-green uk-text-capatilize uk-margin-remove-bottom">{Name}</h3>
                        <h4 class="uk-heading-small uk-margin-remove-top wsio-gold">{Role}</h4>
                        <div class={`${UK || Export ? 'uk-margin-medium}-bottom' : ''}`}>
                            <p>
                                <span hidden={UK ? false : true} class="wsio-gold">UK:</span> {UK}<br />
                                <span hidden={Export ? false : true} class="wsio-gold">Export:</span> {Export}
                            </p>
                        </div>
                        <div>
                            {Links.map((Link) => <AppLink className={`uk-button uk-button-default uk-margin-right uk-margin-top ${Link.Icon == 'mail' ? 'uk-text-lowercase' : ''}`} data={Link} />)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};